import React from "react";

const EditBtn = () => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 62 61"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_50_441)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.1195 5.15332C39.8625 5.15332 46.95 12.0561 46.95 20.5709C46.95 29.0856 39.8625 35.9888 31.1195 35.9888C22.3766 35.9888 15.2891 29.0856 15.2891 20.5709C15.2891 12.0561 22.3766 5.15332 31.1195 5.15332Z"
        fill="#BA004F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.1195 5.15332C39.8625 5.15332 46.95 12.0561 46.95 20.5709C46.95 29.0856 39.8625 35.9888 31.1195 35.9888C22.3766 35.9888 15.2891 29.0856 15.2891 20.5709C15.2891 12.0561 22.3766 5.15332 31.1195 5.15332Z"
        fill="url(#paint0_linear_50_441)"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.0824 15.0515L37.7259 18.6118C38.1283 19.0054 38.1283 19.6432 37.7259 20.0364L31.1673 26.445C31.0202 26.589 30.8397 26.6804 30.6501 26.7191C30.7103 26.8763 30.6626 27.0224 30.4785 27.0338C30.2678 27.0468 26.0372 27.287 25.6757 27.3074C25.4383 27.3204 25.1735 27.0576 25.1849 26.8274C25.1974 26.5709 25.4416 22.4183 25.4653 22.1236C25.4777 21.9679 25.6208 21.9024 25.7866 21.9627C25.8266 21.7786 25.9197 21.6033 26.0661 21.4605L32.6247 15.0515C33.0274 14.658 33.6798 14.658 34.0824 15.0515ZM33.2197 16.8599L27.3301 22.6081V25.2206H30.0073L35.8969 19.4728L33.2197 16.8599Z"
      fill="white"
      fillOpacity="0.75"
    />
    <defs>
      <filter
        id="filter0_d_50_441"
        x="0.289062"
        y="0.15332"
        width="61.6609"
        height="60.8354"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="10" />
        <feGaussianBlur stdDeviation="7.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_50_441"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_50_441"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_50_441"
        x1="31.1196"
        y1="55.26"
        x2="65.7968"
        y2="19.6544"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0208333" stopColor="#EF5395" />
        <stop offset="1" stopColor="#BA004F" />
      </linearGradient>
    </defs>
  </svg>
);

export default EditBtn;
